<div class="modal-header">
  <h4 class="modal-title"> {{'confidentialNoticeTextEditorPopup.title' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <textarea cols="30" rows="10" class="form-control" spellcheck="false"
                formControlName="noticeText"
                [class.is-invalid]="checkControlValidity('noticeText')"
                [readonly]="!hasEditPermission"
                appInputAutoFocus autofocus></textarea>
      <div class="invalid-feedback">{{form.controls.noticeText.errors?.messageKey | translate}}</div>
    </form>
  </div>
</div>
<div class="modal-footer justify-content-between">
  <button type="button" class="btn btn-secondary btn-forward me-auto" (click)="reset()" [disabled]="!hasEditPermission">
    {{ 'confidentialNoticeTextEditorPopup.button.label.revert' | translate }}
  </button>
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{ 'global.label.cancel' | translate }}
  </button>
  <button type="submit" class="btn btn-primary btn-forward" (click)="save()" [disabled]="!hasEditPermission">
    {{'global.label.save' | translate}}
  </button>
</div>
